import { Box, Text } from '@chakra-ui/react';

export const ModalPreview = () => {
  return (
    <Box>
      <Text>ModalPreview - Coming soon</Text>
    </Box>
  );
};
